
import EditInput from '@/components/edit/EditInput';

export default {
    extends: EditInput,

    props: {
        enumKey: {
            type: String,
            default() {
                return this.fieldPath;
            },
        },
    },
};
